import { Fragment, useEffect, useRef, useState } from 'react'
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { ImageUrl, decodeID, getLastURL, replaceToString } from '../../utils/Helper';
import Spinner from '../FieldComponets/Spinner';
import InputField from '../FieldComponets/inputField';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { validateImageFile, validateString } from '../../utils/YupValidation';
import PageLayout from '../Layouts/PageLayout';
import ActionButton from '../FieldComponets/ActionButton';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import React from 'react';
import { url } from '../../Config/Config';
import { VALIDATION_MESSAGE } from '../../Constants/Constants';
import JoditEditor from 'jodit-react';
import { EmailtemplateDetailAction , EmailtemplateUpdateAction } from '../../Redux/Action/EmailTemplateAction';

const formSchema: any = Yup.object().shape({
    title: validateString('title')
});
function EmailManagementEdit() {

    const dispatch = useDispatch<any>()
    const navigate = useNavigate()
    const location = useLocation();
    const editId = getLastURL(location);

    const EmailtemplateDetail = useSelector((state: any) => state.EmailTemplateDetailsState)


    const formSchema: any = Yup.object().shape({
        title: Yup.string()
            .required(VALIDATION_MESSAGE?.ANY_NAME + " Title.")
            .trim(VALIDATION_MESSAGE?.ANY_REQUIRED + " Title")
            // .matches(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/, 'Alphabets & single space is valid')
            .min(2)
            .max(40, "Title" + VALIDATION_MESSAGE?.FULL_NAME_MAX)
    });

    useEffect(() => {
        var params = {
            detail_id: decodeID(editId)
        };
        if (editId) {
            dispatch(EmailtemplateDetailAction(params));
        }

    }, [dispatch, editId]);

    const {
        register,
        handleSubmit,
        setValue,trigger,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            edit_id: decodeID(editId),
            title: ''
        }
    });


    const [content, setContent]: any = useState('');
    const [contentError, setContentError] = useState(false);

    const onSubmit = async (payload: any) => {
        let contentData = replaceToString(content);
        payload.content = content
        payload.user_type = EmailtemplateDetail?.data?.data?.user_type
        payload.subject = payload.title

        if (contentData === '') {
            return setContentError(true)
        }
        await dispatch(EmailtemplateUpdateAction(payload))
        navigate(url + '/email-template')
    }
    const onBlur = (value: string) => {
        setContentError(false)
        setContent(value)
    }

    useEffect(() => {
        if (EmailtemplateDetail?.data) {
            setContent(EmailtemplateDetail?.data?.data?.content);
            setValue("title", EmailtemplateDetail?.data?.data?.title);
        }
    }, [dispatch, EmailtemplateDetail?.data]);

    return (
        <Fragment>
            {EmailtemplateDetail?.loading  ? <Spinner /> : ""}
            <PageLayout title="Edit Email Template" breadcrumbs={{ secLast: { 'link': '/email-template', 'name': 'Email Template' }, Last: { 'name': ' Edit Email Template' } }}>
                <form onSubmit={handleSubmit(onSubmit)} className="card" encType="multipart/form-data">
                    <div className="p-4">
                        <div className="row">
                            <div className="form-group col-md-4">
                                <label htmlFor="fname">Title<span>*</span></label>
                                <InputField
                                    maxLength={40}
                                    minLength={2}
                                    type="text"
                                    className="form-control"
                                    id="title"
                                    placeholder="Enter Title"
                                    register={register('title')}
                                />
                                <p className="text-danger">{errors?.title?.message ?? EmailtemplateDetail?.error?.errors?.title?.message}</p>
                            </div>

                            <div>
                                <label htmlFor="description">Description<span>*</span></label>

                                <JoditEditor
                                    // ref={editor}
                                    value={content}
                                    config={{
                                        theme: '',
                                        events: {
                                            // Handle paste event
                                            paste: (event: ClipboardEvent) => {
                                                event.preventDefault(); // Prevent default paste behavior
                                
                                                // Get the pasted text from the clipboard
                                                const pastedText = event.clipboardData?.getData('text/plain');
                                
                                                // Insert the pasted text into the editor at the current cursor position
                                                if (pastedText) {
                                                    document.execCommand('insertText', false, pastedText);
                                                }
                                            }
                                        }
                                    }}
                                    onBlur={newContent => {
                                        onBlur(newContent);
                                        setContentError(false);
                                    }}
                                />
                                {
                                    contentError ? <p className="text-danger">Please enter description.</p> :
                                        EmailtemplateDetail?.error?.errors?.content?.message
                                }

                            </div>

                        </div>

                        <div className="mt-3">
                            {/* {UpdateTestimonial.loading ? <ButtonSpinner /> : */}
                            <Link to={url + '/email-template'}><button type="button" className="btn btn-secondary ps-3 pe-3 ms-2 back-btn">Back</button></Link>
                            <ActionButton className="btn btn-primary float-start" type="submit" text='Update' />
                            {/* } */}
                        </div>
                        
                    </div>
                </form>
            </PageLayout>
        </Fragment>
    )
}

export default EmailManagementEdit